var version = {
    "name":      "dativery",
    "buildDateCode": "20260907-131249",
    "buildDate": "Mon Sep 07 2026 13:12:49 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260907-131249",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;